export enum UserNotificationsRetrieval {
  PREPARE_RETURN = "prepare_return",
  RETURN_RETURNED = "return_returned",
}

export enum RetrievalStage {
  BOOKED = "booked",
  COLLECTED = "collected",
  FAILED = "failed",
  UNKNOWN = "unknown",
}

export interface RetrievalEvent {
  stage: RetrievalStage;
  date?: string;
}

export interface Retrieval {
  checkout_id: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  containers: any[];
  created: string;
  events: RetrievalEvent[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  helthjem_booking_response: any;
  helthjem_id: string;
  helthjem_return_code: string;
  id: number;
  retrieval_date_original: string;
  retrieval_date: string;
  stage: RetrievalStage;
  user_notifications: UserNotificationsRetrieval[];
}
